import React from 'react'
import iconBoat from '../resourses/embarques.png'
import iconG from '../resourses/servicios0.png'
import iconMion from '../resourses/entregascamiones.png'
import iconCall from '../resourses/servicios2.png'
import iconBuilding from '../resourses/somos.png'
import iconUbication from '../resourses/puertosterminales.png'
import { Container, Row, Col } from 'react-bootstrap'
import SmallCircles from './SmallCircles'

const CirclesHome = () => {
    return (
        <div className="circles-home-wrapper gold">
            <Container className="circles-home-card px-4 px-md-5 pb-4 pb-md-5 pt-2">
                <Row className="justify-content-center align-items-start g-3 g-md-2">
                    <Col xs={6} md={3} className="d-flex justify-content-center">
                        <SmallCircles link="/distancia-entre-puertos" img={iconBoat} text={"Distancia<br/>entre puertos"} />
                    </Col>
                    <Col xs={6} md={3} className="d-flex justify-content-center">
                        <SmallCircles link="/zona-de-servicios" img={iconUbication} text={"Zona de<br/>servicios"} />
                    </Col>
                    <Col xs={6} md={3} className="d-flex justify-content-center">
                        <SmallCircles link="/tipo-de-camiones" img={iconMion} text={"Tipo de<br/>camiones"} />
                    </Col>
                    <Col xs={6} md={3} className="d-flex justify-content-center">
                        <SmallCircles img={iconCall} text={"Consultas sobre<br/>calidades y mermas"} />
                    </Col>
                    <Col xs={6} md={3} className="d-flex justify-content-center">
                        <SmallCircles link="/servicio-de-acondicionamiento" img={iconBuilding} text={"Costo de servicios<br/>de acondicionamiento"} />
                    </Col>
                    <Col xs={6} md={3} className="d-flex justify-content-center">
                        <SmallCircles img={iconG} text={"Normas de<br/>comercialización"} />
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default CirclesHome